import { NgModule, Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ProductsService, DiscountsService } from '../../../../../services';
import { VOLUME_DISCOUNT_UNITS, MERCHANT_TYPE, PAYMENT_TYPE, SYSTEM } from '../../../../../enums';
import { VolumeDiscountApi, StandardDiscountApi, ConfigurationApi } from '../../../../../../assets/js/lb-sdk';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

interface VolumeDiscountForm {
  id?: string,
  productType: { id: string, name: string },
  merchantType?: string,
  paymentType?: string,
  discount: number,
  unit: string,
  minimum: number
}

@Component({
  selector: 'app-volume-discount-form',
  templateUrl: './volume-discount-form.component.html',
  styleUrls: ['./volume-discount-form.component.css']
})
export class VolumeDiscountFormComponent implements OnInit {
  data: VolumeDiscountForm;
  error: string;
  loading: boolean = false;
  standardDiscounts;
  merchantTypes: typeof MERCHANT_TYPE = MERCHANT_TYPE;
  paymentTypes: typeof PAYMENT_TYPE = PAYMENT_TYPE;

  constructor(
    public modal: BsModalRef,
    public productService: ProductsService,
    private volumeDiscountApi: VolumeDiscountApi,
    private standardDiscountApi: StandardDiscountApi,
    private discountsService: DiscountsService,
    private toast: ToastrService
  ) {
    this.discountsService.fetchMaxDiscounts();
  }

  ngOnInit() {
    this.data = this.data || {
      productType: undefined,
      discount: 0,
      unit: VOLUME_DISCOUNT_UNITS.PERCENT,
      minimum: 0
    };
    this.fetchStandardDiscounts();
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    if (form.valid) {
      const {
        id,
        productType,
        merchantType,
        paymentType,
        discount,
        unit,
        minimum
      } = this.data;
      this.error = undefined;
      this.loading = true;
      (id ?
        this.volumeDiscountApi
          .patchAttributes(id, {
            discount,
            unit,
            minimum
          }) :
        this.volumeDiscountApi
          .create({
            productType: productType.name,
            merchantType,
            paymentType,
            discount,
            unit,
            minimum
          })
      ).pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(response => {
        this.modal.content.result = response;
        this.modal.hide();
      }, error => {
        if (error && error.message) {
          this.error = error.message.indexOf('Unique combination') >= 0 ?
            'Already have a volume discount for the product with same minimum quantity' :
            (error.message || 'Failed to create volume discount.');
        } else {
          this.error = 'Failed to create volume discount.';
        }
      });
    }
  }

  fetchStandardDiscounts() {
    this.loading = true;
    this.error = undefined;
    this.standardDiscountApi
      .find()
      .pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(response => {
        this.standardDiscounts = response;
      },
      error => {
        this.error = 'An error occured while fetching the standard discounts.';
      });
  }

  getMaxDiscountOfProduct(productType, merchantType, paymentType) {
    if (productType && productType.name && merchantType && paymentType && SYSTEM.MAX_DISCOUNT[productType.name]) {
      var discount = (this.standardDiscounts || [])
        .filter(standardDiscount => {
          return (
            standardDiscount.productType === productType.name &&
            standardDiscount.merchantType === merchantType &&
            standardDiscount.paymentType === paymentType
          );
        })
        .map(standardDiscount => {
          return {
            rate: standardDiscount.discount,
            unit: 'P' // DEFAULTS TO PERCENT
          }
        })[0];
      return SYSTEM.MAX_DISCOUNT[productType.name] - parseFloat(discount && discount.rate || 0);
    } else {
      return 100;
    }
  }
}
